var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _path14, _path15, _path16, _path17, _rect4, _path18, _path19, _path20, _path21, _path22, _rect5, _path23, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingBotLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 143,
    viewBox: "0 0 145 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68632 38.9443C7.09693 27.5756 15.7261 18.6366 20.1461 14.5811C33.1043 5.39238 39.9835 4.40356 48.6605 3.15631L48.8311 3.13178C62.3441 1.18891 92.1623 1.3679 104.538 5.03778C120.008 9.62513 128.848 18.7998 134.072 28.3734C139.296 37.947 145.323 53.1052 141.506 83.4217C138.452 107.675 125.634 116.53 114.785 122.514L96.9036 131.689L75.4065 141.262C65.361 137.207 41.4528 126.942 26.1836 118.325C7.09718 107.555 3.48083 88.2085 2.47631 83.4217C0.341718 73.2497 2.08733 51.2014 4.68632 38.9443Z",
    fill: "url(#paint0_linear_1777_11466)",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9769 83.1992H3.35156L3.95216 86.2442L4.75295 89.6951L5.95414 93.349L7.55572 97.2059C18.2863 97.3683 26.6413 97.1383 27.7757 96.5969C29.8578 93.8362 29.3773 85.9735 28.9769 83.1992Z",
    stroke: "black",
    strokeWidth: 1.13889
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4377 35.6865C34.3499 26.0626 21.9235 19.6919 17.1055 18.1547C30.148 3.41467 46.4402 2.60187 62.39 1.80615L62.7359 1.78889C75.7823 1.13741 99.9635 1.96641 112.321 7.80396C127.177 14.8215 135.407 27.4529 139.222 39.2824C143.036 51.1118 143.839 71.3622 142.233 81.5877C140.331 93.6963 136.822 113.198 119.95 118.078C101.28 123.478 77.5914 121.674 57.7172 117.076C40.1373 113.008 38.2449 93.6351 37.4417 85.413L37.4415 85.4103C36.6385 77.1898 39.0475 47.7165 36.4377 35.6865Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.36667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.5625,
    y: 95.4219,
    width: 18.9475,
    height: 4.88968,
    rx: 1.48056,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8241 90.2449C54.1749 83.4538 42.7923 82.7666 37.582 83.3729C38.1832 95.0956 38.9848 100.957 44.1951 108.233C48.3348 114.014 55.0166 116.924 62.0304 117.733V101.159C62.0304 94.4893 59.8261 91.9292 58.8241 90.2449Z",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8579 37.5955C27.6681 34.3579 19.8074 29.9844 15.5402 27.8828L10.9922 40.1515C14.0916 40.5604 24.973 46.4562 30.1948 55.9985L32.3846 44.5818C32.2723 43.8434 31.8668 40.5657 29.8579 37.5955Z",
    fill: "#CAA2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1131 114.725L8.54688 98.1719L9.6702 100.248L10.954 102.483C12.6619 105.024 15.2739 108.943 19.5425 112.542C22.9582 115.422 25.702 117.297 32.5334 120.516L40.7882 124.76L61.5694 125.371L84.7954 126.135L104.354 126.746L117.19 120.175L118.565 119.106C102.858 123.369 74.0768 121.671 57.5107 118.621L34.1131 114.725Z",
    fill: "#7057F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1106 127.816H62.7045L71.8086 137.29L50.1106 127.816Z",
    fill: "#383740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3753 86.2539H7.01953L8.54762 90.9806L25.8659 91.1436C26.6809 90.1005 26.7149 87.4492 26.3753 86.2539Z",
    fill: "#826CF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8609 128.43H66.1643L75.7812 138.82L52.8609 128.43Z",
    fill: "#634AE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1094 125.371L106.037 127.446L99.0235 131.181L96.619 132.426L95.0159 133.256L75.3785 142.179L65.9605 138.237L56.5426 133.879L39.1094 125.371Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.911111
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1102 128.43H65.3297L74.5586 138.82L50.1102 128.43Z",
    fill: "#644AE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0276 75.2539H86.174V82.2828L75.0194 98.4799L54.5438 84.2693L44.9173 82.2828L38.6523 79.074L40.0276 75.2539Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.407 45.3047H87.7018V36.2411L76.5113 15.3554L55.9699 33.6796L46.3124 36.2411L40.0273 40.3788L41.407 45.3047Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8047,
    y: 47.1367,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0039,
    y: 45.3047,
    width: 7.02892,
    height: 28.1157,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0236 74.4866L42.1633 70.0553L42.7746 72.3474L44.1493 74.0275L45.6773 74.9444L47.2053 75.4028L43.3584 78.0626L40.0236 74.4866Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6205 75.2162L88.8339 69.1783L88.1601 70.3627L87.8544 71.8907L87.0304 73.4187L85.7152 74.4883L84.34 75.0995L83.1176 75.4052L81.8952 76.2848L87.0304 79.9695L91.6205 75.2162Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2151 74.9453H137.361V81.9742L126.207 98.1713L105.731 83.9607L96.1048 81.9742L89.8398 78.7654L91.2151 74.9453Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5945 44.9961H138.889L134.611 35.9325L120.247 18.8668L107.157 33.371L97.4999 35.9325L91.2148 40.0702L92.5945 44.9961Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.9922,
    y: 46.832,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.215 74.1819L93.3547 69.7506L93.966 72.0427L95.3407 73.7229L96.8687 74.6397L98.3968 75.0981L94.5498 77.758L91.215 74.1819Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.876 75.1005L140.021 68.8737L139.348 70.058L139.042 71.586L138.218 73.114L136.903 74.1836L135.527 74.7949L134.305 75.1005L133.083 75.9801L138.218 79.6648L140.876 75.1005Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1609 45.3026H120.092H134.456L136.748 47.4419L138.581 49.8867L138.887 43.1634L134.456 36.239L119.328 17.951L102.724 33.6776L93.0663 36.239L86.7812 40.3768L88.1609 45.3026Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2151 75.2539H137.361V82.2828L126.207 98.4799L105.731 84.2693L96.1048 82.2828L89.8398 79.074L91.2151 75.2539Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7421 78.3512L97.2715 75.7993L96.187 75.1821L94.7876 74.9023L93.3883 74.1476L92.4087 72.9432L91.849 71.6838L91.5691 70.5643L90.7635 69.4449L87.3891 74.1476L91.7421 78.3512Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3125,
    y: 46.2188,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.125 44.8438L139.959 46.6774L141.792 60.124V67.6113L141.487 73.1122L140.264 80.294L133.388 77.3907L132.93 75.7099L135.222 74.6403L137.667 72.8066V57.3736V49.8862L138.125 44.8438Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_11466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.4688,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1777_11466)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.237,
    cy: 61.0429,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#7600FC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1777_11466)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.2394,
    cy: 60.4306,
    rx: 12.0714,
    ry: 8.09854,
    fill: "#8B14C3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.2734 50.3477H75.0901V70.1643H55.2734V50.3477ZM66.598 61.673C65.7402 61.673 64.9657 61.7003 64.1938 61.6573C63.9043 61.6357 63.6299 61.5195 63.4128 61.3267C62.2882 60.2449 61.2 59.1306 60.0909 58.0293C59.936 57.8757 59.7668 57.7364 59.5598 57.5503V65.8893H70.8219V54.6265H62.4548C62.6904 54.8765 62.8453 55.0483 63.0067 55.211C64.078 56.285 65.1583 57.3498 66.2153 58.4381C66.411 58.6288 66.5386 58.8785 66.5785 59.1488C66.624 59.9455 66.5954 60.7487 66.5954 61.6717L66.598 61.673Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1777_11466)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.9805,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1777_11466)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.745,
    cy: 61.0429,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#7600FC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1777_11466)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.052,
    cy: 60.7353,
    rx: 12.0714,
    ry: 8.09854,
    fill: "#8B14C3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.07 50.3477H125.887V70.1643H106.07V50.3477ZM117.395 61.673C116.537 61.673 115.763 61.7003 114.991 61.6573C114.701 61.6357 114.427 61.5195 114.21 61.3267C113.085 60.2449 111.997 59.1306 110.888 58.0293C110.733 57.8757 110.564 57.7364 110.357 57.5503V65.8893H121.619V54.6265H113.252C113.487 54.8765 113.642 55.0483 113.804 55.211C114.875 56.285 115.955 57.3498 117.012 58.4381C117.208 58.6288 117.336 58.8785 117.375 59.1488C117.421 59.9455 117.392 60.7487 117.392 61.6717L117.395 61.673Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1777_11466",
    x: 35.3401,
    y: 37.258,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_11466"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1777_11466",
    x: 45.8107,
    y: 44.9748,
    width: 38.859,
    height: 30.9098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_11466"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1777_11466",
    x: 84.8479,
    y: 37.258,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_11466"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1777_11466",
    x: 95.6232,
    y: 45.2795,
    width: 38.859,
    height: 30.9098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_11466"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_11466",
    x1: 16.1886,
    y1: 20.3954,
    x2: 55.7102,
    y2: 141.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_11466"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.4688,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1777_11466"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.9766,
    y: 45.3047,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBotLogo5);
export default __webpack_public_path__ + "static/media/TradingBotLogo_5.e286f806c19ea3a438b6b53d7aa23332.svg";
export { ForwardRef as ReactComponent };